import { IJobStatus, PunchListExportLog } from '../../api-client/autogenerated';
import { ApiClient } from '../../api-client/api-client';

export interface PunchListExportSelection {
  locationIds: string[];
  documentIds: string[];
}

/** What the export job writes to `JobStatus.output` once it finishes. */
export interface PunchListExportOutput {
  fileId: string;
  itemCount: number;
}

/** What it writes to `JobStatus.progress` while it is still gathering items. */
export interface PunchListExportProgress {
  itemsCompleted: number;
  itemsTotal: number;
}

/**
 * Queues the export and returns the identifier to follow it by. The PDF is rendered in the
 * background, so this resolves long before the file exists.
 */
export const requestPunchListExport = async (
  projectId: string,
  selection: PunchListExportSelection,
) => {
  // The PDF is rendered on the server, so it is told where this browser is to write its dates as
  // the browser print would.
  const { timeZone, locale } = Intl.DateTimeFormat().resolvedOptions();
  const response = await ApiClient.requestPunchListExport({
    punchListExportRequest: { projectId, ...selection, timeZone, locale },
  });
  return response.data;
};

/** The caller's own exports on the project, and when its punch list last changed. */
export const getPunchListExports = async (projectId: string): Promise<PunchListExportLog> => {
  const response = await ApiClient.getPunchListExports({ projectId });
  return response.data;
};

export const getPunchListExportJobStatus = async (
  uniqueIdentifier: string,
): Promise<IJobStatus> => {
  const response = await ApiClient.getJobStatusByUniqueIdentifier({ uniqueIdentifier });
  return response.data;
};
